import $ from "jquery";

$(() => {
  $("#add-artist").hide();
  $("#create-occurence").hide();

  $(".showAddArtist").click(function () {
    $("#add-artist").fadeIn();
  });

  $(".toggle-create-occurence").click(() => {
    $("#create-occurence").toggle();
  });

  // New artist
  $(".toggleArtistFormButton").click(function () {
    $("#new-artist-form").fadeIn();
  });
  $("#new-artist-form").hide();

  // Venue select
  document.querySelectorAll(".select-other-venue").forEach((select) => {
    select.addEventListener("change", () => {
      document.location = `${select.dataset.root}/${select.value}`;
    });
  });
});
